// extracted by mini-css-extract-plugin
export default {"rating":"mQ-z","numberOfStars":"nQ-z","count":"oQ-z","barGraphSpacing":"pQ-z","barGraph":"qQ-z"};